const formatAccount=(value=>{
    if(value){
        let valueSplit=value.split("@")[0];
        let valueLast=value.split("@")[1];
        if(valueSplit.length<=8){
            return value
        }else{
            return valueSplit.slice(0,3)+'****'+valueSplit.slice(-4)+'@'+valueLast;
        }
    }
});
export default formatAccount



// WEBPACK FOOTER //
// ./src/prestamate/filters/formatAccount.js